

class OverlayStickyATC extends HTMLElement {
    connectedCallback() {
        this.atcButton = document.querySelector('product-form:not(overlay-sticky-atc *) button[name="add"]');
        if (!this.atcButton) return;

        this.observer = new IntersectionObserver(([entry]) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('hidden-sticky', !scrolledPast);
        });

        this.observer.observe(this.atcButton);
    }

    disconnectedCallback() {
        this.observer?.disconnect();
    }
}

customElements.define('overlay-sticky-atc', OverlayStickyATC);